import Login from '../layout/auth/login.vue'
import Home from '../layout/authenticated/home.vue'
import Progress from '../layout/authenticated/progress.vue'
import Certificate from '../layout/authenticated/certificate.vue'
import Collect from '../layout/authenticated/collect.vue'
import Profile from '../layout/authenticated/profile.vue'
import Purchase from '../layout/authenticated/purchase.vue'
import AssessmentInfo from '../layout/authenticated/assessment-info.vue'
import Assessment from '../layout/authenticated/assessment.vue'
import AssessmentResult from '../layout/authenticated/assessment-result.vue'
import Class from '../layout/authenticated/class.vue'
import { storeApp } from '@/store'

export const sharedRoutes = [
  // remover? site
  // {
  //   path: '',
  //   name: 'inicio',
  //   component: Base,
  //   meta: {
  //     public: false,
  //     appC: true
  //   }
  // },

  // login
  {
    path: '/',
    alias: ['/login', '/auth'],
    name: 'auth',
    component: Login,
    meta: {
      public: true
    }
  },

  { // página inicial
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      public: false,
      appC: true,
      menu: 'inicio'
    }
  },
  { // progresso
    path: '/progress',
    name: 'prog',
    component: Progress,
    meta: {
      public: false,
      appC: true,
      menu: 'progresso'
    }
  },
  { // certificados
    path: '/certifications',
    name: 'cert',
    component: Certificate,
    meta: {
      public: false,
      appC: true,
      menu: 'certificados'
    }
  },
  { // coleção de treinamentos e cursos a comprar
    path: '/collect',
    name: 'coll',
    component: Collect,
    meta: {
      public: false,
      appC: true,
      menu: 'colecao'
    }
  },
  { // perfil
    path: '/profile',
    name: 'prof',
    component: Profile,
    meta: {
      public: false,
      appC: true,
      menu: 'perfil'
    }
  },
  { // aula
    path: '/module/:mId?',
    name: 'modu',
    component: Class,
    meta: {
      public: false,
      appC: true,
      menu: 'colecao'
    }
  },
  { // comprar/solicitar curso/treinamento
    path: '/training/:id/purchase',
    name: 'purc',
    component: Purchase,
    meta: {
      public: false,
      appC: true,
      menu: 'colecao'
    }
  },
  
  // prova 
  { // instruções
    path: '/training/:id/assessment-info',
    name: 'avaliable-info',
    component: AssessmentInfo,
    meta: {
      public: false,
      appC: true,
      menu: 'colecao'
    }
  },
  { // prova
    path: '/training/:id/assessment',
    name: 'avaliable',
    component: Assessment,
    meta: {
      public: false,
      appC: true,
      menu: 'colecao'
    }
  },
  { // instruções
    path: '/training/:attemptId/assessment-result/:tId?',
    name: 'avaliable-result',
    component: AssessmentResult,
    meta: {
      public: false,
      appC: true,
      menu: 'colecao'
    }
  },

]
